// Shared age-band presets used by the plan-detail Age × Tier matrix and the
// migration wizard's manual-entry editor. Single source of truth — both
// surfaces show the same dropdown options and the same band labels.

export type AgeBandType = "five_year" | "ten_year";

export const AGE_BAND_PRESETS: Record<AgeBandType, readonly string[]> = {
  five_year: [
    "0-17",
    "18-24",
    "25-29",
    "30-34",
    "35-39",
    "40-44",
    "45-49",
    "50-54",
    "55-59",
    "60-64",
    "64+",
  ],
  ten_year: ["0-17", "18-29", "30-39", "40-49", "50-59", "60-64+"],
};

export const AGE_BAND_TYPE_LABELS: Record<AgeBandType, string> = {
  five_year: "5 Year Age Bands",
  ten_year: "10 Year Age Bands",
};

// Extracts the lower bound of an age band label for sorting. Non-numeric
// prefixes (e.g. "<25") fall to the end via MAX_SAFE_INTEGER. Mirrors the
// helper used in PlanDetailComponents/PlanRates.tsx.
export function parseAgeBandStart(label: string): number {
  const start = label.split("-")[0].replace("+", "");
  const n = parseInt(start, 10);
  return Number.isNaN(n) ? Number.MAX_SAFE_INTEGER : n;
}
